module.exports = __webpack_public_path__ + "img/search_none.cc83606d.png";